<template>
	<div class="base-cta" :class="{'in-dev-message': isInDevelopment, 'mobile-hide': mobileHide}">
		<span
			v-if="isInDevelopment"
			:content="$t(inDevelopmentMessage)"
			@click="() => this.$emit('btnClicked', id)"
			v-tippy="{
				distance: 12,
				placement: 'bottom',
				trigger: disableToolTip ? 'manual' : 'click',
			}"
		>
		</span>
		<div
			class="content"
			:class="{'center-align': id === 'add-products' || id === 'request-quote'}"
			@click="() => this.$emit('btnClicked', id)"
		>
			<div class="copy">
				<h5 v-if="title" class="H5-5 mobile-subtitle-2">
					<base-icon class="shopping-icon" icon-name="shopping" />
					<!-- pdf icon -->
					<base-icon class="quote-icon" icon-name="quote" />
					<!-- pdf icon -->
					{{ title }}
				</h5>
				<p v-if="subheader" class="body-1">{{ subheader }}</p>
			</div>
			<div class="arrow">
				<base-icon icon-name="chevron-right" />
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'WorkflowCta',
	props: {
		title: {
			type: String,
		},
		subheader: {
			type: String,
		},
		id: {
			type: String,
		},
		isInDevelopment: {
			type: Boolean,
		},
		inDevelopmentMessage: {
			type: String,
		},
		enableShareUrl: {
			type: Boolean,
		},
		mobileHide: {
			type: Boolean,
		},
	},
	computed: {
		disableToolTip() {
			return this.enableShareUrl && this.id === 'share-workflow';
		},
	},
};
</script>

<style lang="scss">
.base-cta {
	background-color: $color-super-light-blue;
	position: relative;
	padding: 12px 16px;
	border-radius: 10px;
	cursor: pointer;
	&.in-dev-message {
		span {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			& + div {
				pointer-events: none;
			}
		}
	}
	.content {
		@include flexRow;
		height: 100%;
		.copy {
			flex: 1;
			h5 {
				color: $color-blue;
				margin: 0;
			}
			padding-right: 0.5rem;
		}
		/* pdf icons */
		.shopping-icon,
		.quote-icon {
			display: none;
		}
		.arrow {
			align-self: center;
			color: $color-blue;
		}
	}
}
</style>
